var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.854,117.483a.5.5,0,0,0-.707,0L6,122.629.854,117.483a.5.5,0,0,0-.707.707l5.5,5.5a.5.5,0,0,0,.707,0l5.5-5.5A.5.5,0,0,0,11.854,117.483Z","transform":"translate(0 -117.336)"}));
}

ArrowDownInline.defaultProps = {"width":"12","height":"6.5","viewBox":"0 0 12 6.5"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
